import { FsPointsDistribution } from "../../FsPointsDistribution";
import {
  FsTimeAttackScoringBase,
  FsTimeAttackScoring,
} from "./FsTimeAttackScoring";

export type FsTimeAttackScoringPoints = FsTimeAttackScoringBase & {
  points: FsPointsDistribution | undefined;
};

export const isFsTimeAttackScoringPoints = (
  scoring: FsTimeAttackScoring
): scoring is FsTimeAttackScoringPoints => {
  return scoring.type === "Points";
};
